// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1QVOb","bigColWidth":"Table_bigColWidth__2b1Me","biggerColWidth":"Table_biggerColWidth__1ER_k","row":"Table_row__3RBti","col":"Table_col__2vuIn"};